import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import { getSessionAndMemberStatus } from "@/lib/authz";

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const [redirectTo, setRedirectTo] = useState("/signin");
  const location = useLocation();

  async function evaluate() {
    try {
      const { session, isAnon, isMember } = await getSessionAndMemberStatus();

      if (!session) {
        setAllowed(false);
        setRedirectTo("/signin");
        return;
      }

      if (isAnon) {
        // Optional: sign them out so they don't keep "passing" future checks
        await supabase.auth.signOut();
        setAllowed(false);
        setRedirectTo("/signin?error=anon_not_allowed");
        return;
      }

      if (!isMember) {
        setAllowed(false);
        setRedirectTo("/requestaccess");
        return;
      }

      setAllowed(true);
    } catch (e) {
      console.error(e);
      setAllowed(false);
      setRedirectTo("/signin?error=authz");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let alive = true;

    evaluate();

    const { data: sub } = supabase.auth.onAuthStateChange(() => {
      if (!alive) return;
      setLoading(true);
      evaluate();
    });

    return () => {
      alive = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <p className="font-sans text-base opacity-80">Loading…</p>
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
  }

  return children;
}
